import * as React from 'react'

import { ChildListenerContext } from './context'

export const withChildListenerConsumer = <P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P & any> => (props: P) => (
  <ChildListenerContext.Consumer>
    {context => <Component {...props} childListenerContext={context} />}
  </ChildListenerContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/components/ChildListener/withChildListenerConsumer.tsx